import request from "@/plugins/axiosRequest";

const url = "/api/dashboard/v1/withdrawn_requests";

export function fetchList(query) {
  return request({
    url: url,
    method: "get",
    params: query
  });
}

export function postNewRequest(data) {
  return request({
    url: url,
    method: "post",
    data
  });
}

export function updateWithdrawal(data) {
  return request({
    url: `${url}/${data.id}`,
    method: "PUT",
    data
  });
}

export function resendConfirmation(id) {
  return request({
    url: `${url}/${id}/resend-confirmation`,
    method: "POST"
  });
}

export function cancelConfirmation(id) {
  return request({
    url: `${url}/${id}/cancel-confirmation`,
    method: "POST"
  });
}